// The server resends explosions (smoke, flash, frag) with every snapshot until it knows one
// arrived, so a lost datagram does not lose them (`gr-server` game/snapshot.rs). The copies are
// identical on the wire: an explosion counts once, when its first copy shows up.

import { wholeTicks } from "../net/constants";
import type { FxEventData } from "../wasm/types";

export type ExplosionEvent = Extract<FxEventData, { kind: "explosion" }>;

/** `RESEND_TICKS` of the server: the last copy of an event is sent this many ticks (0.4 s) after it happened. */
export const FX_RESEND_TICKS = wholeTicks(0.4);

interface Seen {
  tick: number;
  ev: ExplosionEvent;
}

export class ExplosionDedupe {
  private seen: Seen[] = [];

  /** Whether `ev`, carried by the snapshot of `tick`, is new (not a resent copy of one already taken). */
  isNew(tick: number, ev: ExplosionEvent): boolean {
    const seen = this.seen;
    let kept = 0;
    let duplicate = false;
    for (const s of seen) {
      if (tick - s.tick >= FX_RESEND_TICKS) continue;
      seen[kept++] = s;
      if (s.ev.equipment === ev.equipment && s.ev.pos.x === ev.pos.x && s.ev.pos.y === ev.pos.y && s.ev.pos.z === ev.pos.z) {
        duplicate = true;
      }
    }
    seen.length = kept;
    if (!duplicate) seen.push({ tick, ev });
    return !duplicate;
  }

  clear(): void {
    this.seen.length = 0;
  }
}
